import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Avatar } from '@tillersystems/stardust';

import { Body, Name, Resume } from './elements';

/**
 * MyCsm
 *
 * This component is in charge of displaying
 * the csm of a client
 *
 * @return {jsx}
 */

const MyCsm = ({ className, name, avatarUrl }) => (
  <div className={className}>
    <Avatar name={name} src={avatarUrl} size={6} />
    <Body>
      <Name>{name}</Name>
      <Resume>
        Vivamus sagittis lacus vel augue laoreet rutrum faucibus dolor auctor. Duis mollis, est non
        commodo luctus.
      </Resume>
    </Body>
  </div>
);

/**
 * PropTypes Validation
 */
const { string } = PropTypes;
MyCsm.propTypes = {
  className: string,
  name: string.isRequired,
  avatarUrl: string,
};

/**
 * Default Props
 */
MyCsm.defaultProps = {
  className: '',
  avatarUrl: null,
};

export default styled(MyCsm)`
  display: flex;

  padding-bottom: 3rem;
  margin-bottom: 3rem;

  border-bottom: 1px solid ${({ theme: { palette } }) => palette.lightGrey};
`;



// WEBPACK FOOTER //
// ./src/components/MyCsm/index.js